import type { ReactElement } from "react";
import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/dev/prototypes/")({
	component: PrototypeIndex,
});

function PrototypeIndex(): ReactElement {
	return (
		<div className="mx-auto max-w-4xl px-6 py-12">
			<h1 className="mb-2 text-2xl font-semibold">Prototypes</h1>
			<p className="text-muted mb-8">
				Page prototypes for exploring layouts and interactions with real
				components.
			</p>

			<div className="space-y-2">
				<Link
					to="/dev/prototypes/landing-v1"
					target="_blank"
					className="border-border hover:border-subtle hover:bg-card block rounded-lg border p-4 no-underline transition-colors"
				>
					<span className="text-foreground font-medium">
						Landing Page v1
					</span>
					<span className="text-muted ml-2 text-sm">Scaffold</span>
				</Link>
				<Link
					to="/dev/prototypes/landing-v1-components"
					search={{ focus: undefined }}
					target="_blank"
					className="border-border hover:border-subtle hover:bg-card block rounded-lg border p-4 no-underline transition-colors"
				>
					<span className="text-foreground font-medium">
						Landing v1 — Components
					</span>
					<span className="text-muted ml-2 text-sm">Showcase</span>
				</Link>
				<Link
					to="/dev/prototypes/clearvoid-v1"
					target="_blank"
					className="border-border hover:border-subtle hover:bg-card block rounded-lg border p-4 no-underline transition-colors"
				>
					<span className="text-foreground font-medium">
						Clearvoid Detail v1
					</span>
					<span className="text-muted ml-2 text-sm">
						Content detail page
					</span>
				</Link>
				<Link
					to="/dev/prototypes/clearvoid-v1-components"
					search={{ focus: undefined }}
					target="_blank"
					className="border-border hover:border-subtle hover:bg-card block rounded-lg border p-4 no-underline transition-colors"
				>
					<span className="text-foreground font-medium">
						Clearvoid v1 — Card Variants
					</span>
					<span className="text-muted ml-2 text-sm">Showcase</span>
				</Link>
				<Link
					to="/dev/prototypes/trees"
					target="_blank"
					className="border-border hover:border-subtle hover:bg-card block rounded-lg border p-4 no-underline transition-colors"
				>
					<span className="text-foreground font-medium">
						Tree Views
					</span>
					<span className="text-muted ml-2 text-sm">
						4 layout variants
					</span>
				</Link>
			</div>
		</div>
	);
}
